import { Component, OnChanges, Input, SimpleChanges, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';
import { Time } from "src/app/_api/models/time.model";
import { TimesService } from "src/app/_api/services/times.service";
import { TimeService } from 'src/app/modules/time/_api/services/time.service';
import { LanguageService } from "src/app/shared/services/language.service";
import { TimeLogEventHandler } from "../time-log/time-log-event.service";
import { TimeLogComponent } from "../time-log/time-log.component";
import { Addition } from "src/app/_api/models/addition.model";
import { Expense } from "src/app/_api/models/expense.model";
import { SystemsService } from "src/app/_api/services/systems.services";
import { AdditionsService } from "src/app/_api/services/additions.service";
import { ExpensesService } from "src/app/_api/services/expenses.service";
import { TransportArticle } from "src/app/_api/models/transport-article.model";
import { TransportArticlesService } from "src/app/_api/services/transport-articles.service";
import { DateRangeEventService } from "src/app/shared/services/date-range-event.service";
import { DataGridComponent } from "src/app/shared/_devextreme/data-grid/data-grid.component";
import { ProjectPortalApprovalEmployeeAdditionsComponent } from "./additions/additions.component";
import { ProjectPortalApprovalEmployeeExpensesComponent } from "../project-portal-list-detail-employee/expenses/expenses.component";
import { Subscription } from "rxjs";
import * as moment from "moment";
import { TimesalaryapprovalDetailTimeComponent } from "src/app/modules/time/timesalaryapproval/timesalaryapproval-detail/timesalaryapproval-detail-time/timesalaryapproval-detail-time.component";
import { PortalTypeService } from '../../../../../shared/services/portal-type.service';

@Component({
  selector: 'app-project-portal-list-detail-employee',
  templateUrl: './project-portal-list-detail-employee.component.html',
  styleUrls: ['./project-portal-list-detail-employee.component.css']
})
export class ProjectPortalListDetailEmployeeComponent implements OnInit, OnChanges {
  @Input() weekOverview = [];
  @Input() transportWeekOverview = [];
  @Input() selectedWeekNo: number;
  @Input() selectedTimeRecord: any;
  @Input() selectedDateInterval: any;
  @Input() dateRangeSelectedIndex: number;
  @Input() employees = [];
  @Input() selectedProjectId: number;
  @Input() timeSalaryTimeComponent: TimesalaryapprovalDetailTimeComponent;
  @Input() projectReadWriteAll: boolean;
  @Input() projectReadAll: boolean; 
  @Input() overTimeCheckActive: boolean; 
  @Input() employeeHasProjectPermissions: boolean;
  @Input() portalType: string; 

  @Output() cellPrepared = new EventEmitter<any>();

  @ViewChild(TimeLogComponent) timeLog: TimeLogComponent;

  times: Time[] = [];
  transport: any;
  transportEquipments: any = [];
  transportArticleTypes: any = [];
  equipments = [];
  additionTypes: any = [];
  expenseTypes: any = [];
  articles: TransportArticle[] = [];
  additions: Addition[] = [];
  expenses: Expense[] = [];

  dateRangeEventSubscription: Subscription;
  dateInterval: any = { FromDate: moment(), ToDate: moment() };

  @Input() gridSections: any = [];
  isTransport: boolean;

  @ViewChild("additionsGrid", { static: false }) additionsGrid: DataGridComponent;
  @ViewChild("expensesGrid", { static: false }) expensesGrid: DataGridComponent;
  @ViewChild("projectApprovalAdditions", { static: false }) projectApprovalAdditions: ProjectPortalApprovalEmployeeAdditionsComponent;
  @ViewChild("projectApprovalExpenses", { static: false }) projectApprovalExpenses: ProjectPortalApprovalEmployeeExpensesComponent;

  constructor(
    public languageService: LanguageService,
    private timesService: TimesService,
    private timeService: TimeService,
    private timeLogEventHandler: TimeLogEventHandler,
    private systemService: SystemsService,
    private additionsService: AdditionsService,
    private expensesService: ExpensesService,
    private transportArticlesService: TransportArticlesService,
    private dateRangeEventService: DateRangeEventService,
    private portalTypeService: PortalTypeService ) {

      this.dateRangeEventSubscription = this.dateRangeEventService.onDateRangeChanged().subscribe((dateInterval) => {
        if (dateInterval) {
          this.dateInterval = dateInterval;
        }
      });
      
    this.timeLogEventHandler.onTimeAdded().subscribe((time: any) => {
      this.times.push(time);
      this.filterTimesByEmployeeAndInterval();
    });

    this.timeLogEventHandler.onTimeUpdated().subscribe((time: any) => {
      const recordIndex = this.times.findIndex(t => t.TimeId === time.TimeId);
      this.times[recordIndex] = time;
      this.filterTimesByEmployeeAndInterval();
    });

    this.timeLogEventHandler.onTimeDeleted().subscribe((id: number) => {
      this.times = this.times.filter((t: any) => t.TimeId !== id);
    });
  }

  private filterTimesByEmployeeAndInterval() {
    const fromDate = new Date(this.selectedDateInterval.FromDate.format("YYYY-MM-DD"));
    const toDate = new Date(this.selectedDateInterval.ToDate.format("YYYY-MM-DD"));
    this.times = this.times.filter((t: any) => t.EmployeeId === this.selectedTimeRecord?.EmployeeId &&
      new Date(moment(t.Date).format("YYYY-MM-DD")) >= fromDate &&
      new Date(moment(t.Date).format("YYYY-MM-DD")) <= toDate);
  }

  ngOnInit() {
    this.loadTransportArticles();
    this.loadEquipments();
    this.loadAdditionTypes();
    this.loadExpenseTypes();
  }

  private async loadTransportArticles(): Promise<any> {
    const articleTypeResponse = await this.timeService.getTransportArticles().toPromise();
    this.transportArticleTypes = articleTypeResponse.Data;
  }

  private async loadEquipments(): Promise<any> {
    const equipmentResponse = await this.timeService.getEquipment().toPromise();
    this.equipments = equipmentResponse.Data;
  }

  private async loadAdditionTypes(): Promise<any> {
    const additionTypeResponse = await this.additionsService.getAdditionTypes().toPromise();
    this.additionTypes = additionTypeResponse.Data;
  }

  private async loadExpenseTypes(): Promise<any> {
    const expenseTypeResponse = await this.expensesService.getExpenseTypes().toPromise();
    this.expenseTypes = expenseTypeResponse.Data;
  }

  ngOnChanges(changes: SimpleChanges) {
    const hasChangedSelectedTimeRecord = changes.selectedTimeRecord !== undefined && changes.selectedTimeRecord.previousValue !== changes.selectedTimeRecord.currentValue;
    const hasChangedSelectedDateInterval = changes.selectedDateInterval !== undefined && changes.selectedDateInterval.previousValue !== changes.selectedDateInterval.currentValue;

    if (hasChangedSelectedTimeRecord === false && hasChangedSelectedDateInterval === false) { return; }
    this.loadData();
  }

  onCellPrepared(e: any) {
    this.cellPrepared.emit(e);
  }

  private async loadData() {
    if (!this.selectedTimeRecord) { 
      this.transport = null;
      this.transportWeekOverview = this.times = this.additions = this.transportEquipments = this.articles = this.expenses = [];
      return; 
    }

    this.loadTransport();
    this.loadTimes();
    this.loadAdditions();
    this.loadTransportEquipment();
    this.loadArticles();    
    this.loadExpenses();
  }

  private async loadTransport(): Promise<any> {
    const transportResponse = await this.timeService.getTransportFromTimeId(this.selectedTimeRecord.TimeId).toPromise();

    if (transportResponse.IsSuccess) {
      this.transport = transportResponse.Data;
    }
  }

  private async loadTransportEquipment(): Promise<any> {
    if (!this.selectedTimeRecord.IsTransport) {
      this.transportEquipments = (await this.timeService.getTransportEquipmentByCarrierEmployeeDate(this.selectedTimeRecord.CarrierId, 
        this.selectedTimeRecord.EmployeeId, this.selectedTimeRecord.Date).toPromise())?.Data; 
    }
    else this.transportEquipments = (await this.timeService.getTransportEquipmentByCarrier(this.selectedTimeRecord.CarrierId).toPromise())?.Data;
  }

  private async loadArticles(): Promise<any> {
    this.articles = await this.transportArticlesService.getByTime(this.selectedTimeRecord.TimeId).toPromise();
  }

  private async loadAdditions(): Promise<any> {
    if (this.portalTypeService.isProjectPortal(this.portalType)) {
      this.additions = await this.additionsService.getByTime(this.selectedTimeRecord.TimeId).toPromise();      
    }
    else {
      this.additions = await this.additionsService
        .getByTimeEmployeeWithinPeriod(this.selectedTimeRecord.TimeId, this.selectedTimeRecord.EmployeeId, this.dateInterval.FromDate, this.dateInterval.ToDate)
        .toPromise();
    }    
  }

  private async loadExpenses(): Promise<any> {
    if (this.portalTypeService.isProjectPortal(this.portalType)) {
      this.expenses = await this.expensesService.getByTime(this.selectedTimeRecord.TimeId).toPromise();
    }
    else {
      this.expenses = await this.expensesService
        .getByTimeEmployeeWithinPeriod(this.selectedTimeRecord.TimeId, this.selectedTimeRecord.EmployeeId, this.dateInterval.FromDate, this.dateInterval.ToDate)
        .toPromise();
    }
  }

  private async loadTimes(): Promise<any> {
    this.isTransport = this.selectedTimeRecord.CategoryId === 8;

    if (!this.isTransport) {
      this.times = await this.timesService.getByProjectAndEmployeeWithinPeriod(this.selectedTimeRecord.CarrierProjectId, this.selectedTimeRecord.EmployeeId, this.selectedDateInterval.FromDate, this.selectedDateInterval.ToDate, this.selectedTimeRecord.CategoryId, this.selectedTimeRecord.TimeTypeId).toPromise();
      return;
    }
    
    const transportTimes = await this.timeService.getTransportFromTimeId(this.selectedTimeRecord.TimeId).toPromise();
    this.times = transportTimes.Data.TimeLog;
  }
}
